<template>
    <button
        class="button is-fullwidth"
        :class="job.relevant === true ? 'is-primary' : job.relevant === false? 'is-danger' : 'is-light is-info'"
        @click="$emit('load_job_description', job.ranked_job_id, job.id, job.relevant)"
    >{{ badgeText }}
    </button>
</template>
<script setup lang="ts">
import { computed } from "vue"

const props = defineProps<{
  job: any
}>()

defineEmits<{
  load_job_description: [jobId: any, matchId: any, relevant: boolean | null]
}>()

const badgeText = computed(() =>
  props.job.relevant === true ? "Interested" :
  props.job.relevant === false ? "Not Interested" :
  "Check Me Out"
)
</script>
